import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addUser } from "../features/user/userSlice";
import { useDispatch } from "react-redux";
import { ACCESS_TYPE_OPTIONS } from "../utils/constants";

const AddUserLayer = () => {

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    role: "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { username, email, role } = formData;

    if (!username.trim()) {
      toast.error("Full Name is required");
      return;
    }
    if (!email.trim()) {
      toast.error("Email is required");
      return;
    }
    if (!role.trim()) {
      toast.error("Role is required");
      return;
    }

    // Submit logic
    try {
      console.log("Submitting data:", formData);
      const result = await dispatch(addUser(formData)).unwrap();

      if (result.success) {
      toast.success("User created successfully!");
      setFormData({ username: "", email: "", role: "" });
      window.location.href = "/users-list"; // Redirect to users page after successful creation
      } else {
      toast.error("Failed to save user. Please try again.");
      }
    } catch (error) {
      console.error("Error saving user:", error);
      toast.error("An error occurred while saving the user.");
    }
  };

  return (
    <div className='card h-100 p-0 radius-12'>
      <div className='card-body p-24'>
        <div className='row justify-content-center'>
          <div className='col-xxl-6 col-xl-8 col-lg-10'>
            <div className='card border'>
              <div className='card-body'>
                <form onSubmit={handleSubmit}>
                  <div className='mb-20'>
                    <label htmlFor='name' className='form-label fw-semibold text-primary-light text-sm mb-8'>
                      Full Name <span className='text-danger-600'>*</span>
                    </label>
                    <input
                      type='text'
                      className='form-control radius-8'
                      id='username'
                      value={formData.username}
                      onChange={handleInputChange}
                      placeholder='Enter Full Name'
                    />
                  </div>
                  <div className='mb-20'>
                    <label htmlFor='email' className='form-label fw-semibold text-primary-light text-sm mb-8'>
                      Email <span className='text-danger-600'>*</span>
                    </label>
                    <input
                      type='email'
                      className='form-control radius-8'
                      id='email'
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder='Enter email address'
                    />
                  </div>
                  <div className='mb-20'>
                    <label htmlFor='role' className='form-label fw-semibold text-primary-light text-sm mb-8'>
                      Role <span className='text-danger-600'>*</span>
                    </label>
                    <select
                      className='form-control radius-8 form-select'
                      id='role'
                      value={formData.role}
                      onChange={handleInputChange}
                    >
                      {ACCESS_TYPE_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                        ))}
                    </select>
                  </div>
                  <div className='d-flex align-items-center justify-content-center gap-3'>
                    <button
                      type='button'
                      className='border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8'
                      onClick={() => setFormData({ username: "", email: "", role: "" })}
                    >
                      Cancel
                    </button>
                    <button
                      type='submit'
                      className='btn btn-bg border border-primary-600 text-md px-56 py-12 radius-8'
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    </div>
  );
};

export default AddUserLayer;